import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import FacilityPage from './Facility/FacilityPage';
import './styles.scss';

interface PublicFacilityProfileProps extends RouteComponentProps<{ facilityName: string; facilityId: string }> {}

class PublicFacilityProfile extends Component<PublicFacilityProfileProps> {
  render() {
    return (
      <div className="public-profiles-wrapper">
        <FacilityPage />
      </div>
    );
  }
}

export default withRouter(PublicFacilityProfile);
